import { Injectable } from '@angular/core';
import swal from 'sweetalert';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SessionService } from '../../services/session.service';

@Injectable()
export class Sweetalert {
    constructor(
        private location: Location,
        private router: Router,
        private sessionService: SessionService
    ) {}

    onCreate(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            buttons: [false],
            closeOnClickOutside: false,
            timer: 1500
        }).then(() => {
            this.location.back();
        });
    }

    onlySuccess(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            buttons: [false],
            closeOnClickOutside: false,
            timer: 1500
        });
    }

    confirmSuccess(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            buttons: [false],
            closeOnClickOutside: false
        }).then(() => {
            this.location.go('/');
        });
    }

    onDelete(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            buttons: [false],
            closeOnClickOutside: false,
            timer: 1500
        });
    }

    onWarning(message: string) {
        swal({
            title: 'Atenção',
            text: message,
            icon: 'warning',
            buttons: [false, 'Fechar'],
            closeOnClickOutside: true
        });
    }

    onError(response = null) {
        swal({
            title: 'Falha',
            text:
                response === null
                    ? 'Houve uma falha na comunicacao, tente novamente mais tarde'
                    : response,
            icon: 'error',
            buttons: [true],
            closeOnClickOutside: false
        });
    }

    onErrorSubmit(response) {
        swal({
            title: 'Falha',
            text: response,
            icon: 'error',
            buttons: [false, 'Fechar'],
            closeOnClickOutside: true
        });
    }

    onColaboradorConviteComplete(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            buttons: [false],
            closeOnClickOutside: false,
            timer: 1500
        }).then(() => {
            this.location.go('/');
            location.reload();
        });
    }

    onParticipanteComplete(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            closeOnClickOutside: false,
            buttons: [false, 'ENTRAR NA PLATAFORMA']
        }).then(() => {
            this.location.go('/area-do-participante/estudos-clinicos');
            location.reload();
        });
    }

    goToSite(response) {
        swal({
            title: 'Sucesso',
            text: response,
            icon: 'success',
            closeOnClickOutside: false,
            buttons: [false, 'ENTRAR NA PLATAFORMA']
        }).then(() => {
            this.router.navigate([
                '/externalRedirect',
                { externalUrl: 'https://cidpbrasil.com.br' }
            ]);
        });
    }

    termoUso(txt) {
        swal({
            title: 'TERMO DE USO',
            text: txt,
            icon: '',
            closeOnClickOutside: true,
            buttons: [false, 'Fechar']
        });
    }

    privacidade(txt) {
        swal({
            title: 'POLÍTICA DE PRIVACIDADE',
            text: txt,
            icon: '',
            closeOnClickOutside: true,
            buttons: [false, 'Fechar']
        });
    }

    withoutPermission(response) {
        swal({
            title: 'Acesso Bloqueado',
            text: response,
            icon: 'warning',
            buttons: [false],
            closeOnClickOutside: false,
            timer: 2500

        }).then(() => {
            this.sessionService.logOff();
        });
    }

    onAtivacaoConta(txt, sucesso) {
        swal({
            title: sucesso ? "Sucesso" : "Erro",
            text: txt,
            icon: sucesso ? "success" : "error" ,
            buttons: [false, (sucesso ? "CONTINUAR" : "TENTAR NOVAMENTE")],
            closeOnClickOutside: false
        }).then((res) => {
            if(sucesso)  {
                this.location.go('/area-do-participante/cadastro');
                window.location.reload();
            }
        });
        
    }

    resetCodigoAtivacao(msg) {
        swal({
            title : "Sucesso",
            text : msg,
            icon : 'success',
            closeOnClickOutside : false,
            buttons: [false, 'OK']
        }).then(res => {
            
        });
    }

    resetSenha(msg) {
        swal({
            title : "Sucesso",
            text : msg,
            icon : 'success',
            closeOnClickOutside : false,
            buttons: [false, 'OK']
        }).then(res => {
            this.location.go("/participante/login");
            location.reload()
        });
    }

}
